import React, { useState, useRef, useEffect } from "react";
import BackArrow from "../icons/BusinessHub/BackArrow";
import "../styles/AddUser.css";
import BusinessHubHeader from "../components/BusinessHubHeader.js";
import SuccTickIcon from "../icons/BusinessHub/SuccTickIcon.js";
import { useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import UserInfoInput from "./UserInfoInput.js";
import Utils from "../utils/Utils.js";
import companyController from "../controllers/companyController.js";
import { toast } from "react-toastify";
import { userService } from "../services/userService";

function AddUser() {
  const [UserAdd, setUserAdded] = useState(false);
  const [jwt, setjwt] = useState("");
  const [roleID, setRoleID] = useState("");
  const childRef = useRef();
  const navigate = useNavigate();

  useEffect(() => {
    setjwt(userService.getUser());
  }, []);

  const handleCreateUser = async () => {
    const Pjwt = Utils.parseJwt(jwt);
    const data = childRef.current.getData();
    try {
      if (childRef.current) {
        if (
          !data.fname ||
          !data.lname ||
          !data.phone ||
          !data.birthdate ||
          !data.email ||
          !data.roleID ||
          !data.gender
        ) {
          toast.error("Fill All Data");
          return;
        }
        const Gender = data.gender.toLocaleUpperCase();
        const pronoun =
          Gender === "FEMALE" ? "HER" : Gender === "MALE" ? "HIS" : "THEIR";
        const addCompanyEmloyeeRequest = {
          adminID: Pjwt.id,
          birthdate: data.birthdate,
          companyID: userService.getCompID(),
          gender: {
            costumGenderName: null,
            genderName: Gender,
            pronoun: pronoun,
          },
          roleID: data.roleID,
          userID: null,
          userRegister: {
            countryOfResidence: data.countryofres.label,
            email: data.email,
            firstname: data.fname,
            lastname: data.lname,
            password: null,
            phoneNumber: data.phone,
            suffix: data.phoneDialCode,
            userType: "END_USER",
          },
        };
        const AddCompanyEmployees = await companyController.addCompanyEmployees(
          { jwt: jwt, addCompanyEmloyeeRequest: addCompanyEmloyeeRequest },
        );
        if (
          AddCompanyEmployees.data &&
          Utils.isSuccessResponse(AddCompanyEmployees)
        ) {
          setUserAdded(true);
        } else if (
          !AddCompanyEmployees.data &&
          !Utils.isSuccessResponse(AddCompanyEmployees)
        ) {
          toast.error(AddCompanyEmployees.response.data.message);
        }
      }
    } catch (err) {
      console.log(err, "");
    }
  };

  return (
    <div className="new-user-screen-container">
      <div className="new-user-page-header">
        <BusinessHubHeader />
      </div>
      <div className="new-user-content-main-container">
        {UserAdd && (
          <div className="popup-container">
            <div
              className="popup-content-container"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="popup-content">
                <div className="successfully-added-icon">
                  <SuccTickIcon />
                </div>
                <div className="successfully-added-text">
                  User Added Successfully
                </div>
                <div
                  className="successfully-added-action-button"
                  onClick={() =>
                    navigate("/user-management", {
                      state: { active: "C" },
                    })
                  }
                >
                  Continue
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="new-user-content-container">
          <div className="new-user-header">
            <div className="new-user-header-navigation">
              <div
                className="new-user-header-navigation-icon"
                onClick={() =>
                  navigate("/user-management", {
                    state: { active: "C" },
                  })
                }
              >
                <BackArrow />
              </div>
              <div className="new-user-header-navigation-text">
                Back to User Management
              </div>
            </div>
            <div className="new-user-header-text">
              <div className="new-user-header-title">Add New User</div>
              <div className="new-user-header-text-note">
                Create a new user account for your company
              </div>
            </div>
          </div>
          <div className="new-user-body">
            <div className="new-user-window-container">
              <div className="user-window-header">
                <div className="user-window-header-text-container">
                  <div className="user-window-title">User Information</div>
                  <div className="user-window-text">
                    Enter the details for the new user account
                  </div>
                </div>
              </div>
              <UserInfoInput
                ref={childRef}
                UserAdd={UserAdd}
                RoleID={roleID}
                setRoleid={setRoleID}
                setUserAdded={setUserAdded}
                mode="add"
              />
              <div className="user-window-footer">
                <div className="user-window-footer-button-container">
                  <div
                    className="create-user-action-button"
                    onClick={() => handleCreateUser()}
                  >
                    Create User
                  </div>
                  <div className="canel-action-button-container">
                    <div
                      className="cancel-user-creation-action-button"
                      onClick={() =>
                        navigate("/user-management", {
                          state: { active: "C" },
                        })
                      }
                    >
                      Cancel
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="new-user-footer">
            <div className="new-user-footer-container">
              <div className="new-user-footer-container-title">
                New User Invitation
              </div>
              <div className="new-user-footer-container-text">
                The new user will receive an email invitation to set up their
                password and complete their profile. They will have access to
                the company data based on their assigned role.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddUser;
